import { I18N_DOMAIN } from '../settings';
import PrePublishHeader from './prepublish/PrePublishHeader';

const { compose } = wp.compose;
const { withDispatch, withSelect } = wp.data;
const { Component } = wp.element;
const { __, sprintf } = wp.i18n;

class PodcastTitleComponent extends Component {
	isBlocked = () => {
		const { postTitle } = this.props;
		if (postTitle === '') {
			return true;
		}
		return false;
	};

	render() {
		const { updatedStatus } = this.props;
		let title = 'published';
		if (updatedStatus === 'updated' || updatedStatus === 'publish') {
			title = 'updated';
		}
		const heading = `A Podcast cannot be ${title} without Title.`;

		return (
			<>
				<PrePublishHeader.Approval name="ib-podcast-title" display={this.isBlocked} type="blocker">
					<p>{sprintf(__('%s', I18N_DOMAIN), heading)}</p>
				</PrePublishHeader.Approval>
			</>
		);
	}
}

export default compose([
	withSelect(select => {
		const { getEditedPostAttribute } = select('core/editor');
		const postTitle = getEditedPostAttribute('title');
		const updatedStatus = getEditedPostAttribute('status');

		return {
			postTitle,
			updatedStatus,
		};
	}),
	withDispatch(dispatch => ({
		editPost: dispatch('core/editor').editPost,
	})),
])(PodcastTitleComponent);
